import { useAtom } from 'jotai';
import { useState } from 'react';
import { Form as BaseForm, Spin, Space } from 'antd';
import useRecaptcha from '../../hooks/useRecaptcha';
import formSubmissionsAtomFactory from '../../data/atoms/form-submissions';
import { Subtitle } from '../../components/typography';
import Image from '../../components/image';

function Form({ type, name, hiddenData = {}, children }) {
  const [formSubmissions, dispatch] = useAtom(formSubmissionsAtomFactory(type));
  const [form] = BaseForm.useForm();
  const [dispatchSucceed, setDispatchSucceed] = useState(false);

  const { execute } = useRecaptcha();

  const onSubmitForm = (request) => {
    request.data = {
      ...hiddenData,
      ...request.data
    };

    execute(`${type}_request`, (token) => {
      dispatch({
        type: "create",
        data: {
          type: type,
          recaptchaToken: token,
          ...request,
        },
        callback: (newState) => {
          setDispatchSucceed(true);
          if (newState.success) {
            form.resetFields();
          }
        }
      });
    });
  };

  return (
    <Spin spinning={formSubmissions.running} tip="Sending" style={{ width: "100%", minHeight: "35em" }}>
      {
        (dispatchSucceed === true && formSubmissions.success === true && formSubmissions.data.successMessage)
          ?
          <Space direction="vertical" size={[28, 28]} align="center" style={{ width: "100%", textAlign: "center" }}>
            <Subtitle>{formSubmissions.data.successMessage.title}</Subtitle>
            {formSubmissions.data.successMessage.image && <Image data={formSubmissions.data.successMessage.image} icon size="7x" style={{ color: "var(--success-color)" }} />}
            <div className="bccampus-cms-content" dangerouslySetInnerHTML={{ __html: formSubmissions.data.successMessage.content }} />
          </Space>
          :
          <>
            <BaseForm name={name} form={form}
              layout="vertical"
              onFinish={onSubmitForm}
              validateTrigger="onBlur"
            >
              {children}
            </BaseForm>

            {(formSubmissions.running === false && formSubmissions.success === false && formSubmissions.data.failureMessage) &&
              <Space direction="vertical" size={[28, 28]} align="center" style={{ width: "100%", textAlign: "center" }}>
                <Subtitle>{formSubmissions.data.failureMessage.title}</Subtitle>
                {formSubmissions.data.failureMessage.image && <Image data={formSubmissions.data.failureMessage.image} icon size="7x" style={{ color: "var(--error-color)" }} />}
                <div className="bccampus-cms-content" dangerouslySetInnerHTML={{ __html: formSubmissions.data.failureMessage.content }} />
              </Space>
            }
          </>
      }
    </Spin>
  );
}

export default Form;
